<button id="dashed-button" data-cy="add_reso_btn" (click)=addChoice()>
  <span *ngIf="buttonPlus">+&nbsp;&nbsp;&nbsp;</span>{{buttonText}}
</button>